import Fingerprint from "@material-ui/icons/Fingerprint";
import PermIdentity from "@material-ui/icons/PermIdentity";
import PropTypes from "prop-types";
import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { get, isEqual, values } from "lodash";

import BouncingLoader from "components/EnergyCompany/BouncingLoader/BouncingLoader.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { CPFMask, removeNonDigits, telefoneMask } from "services/utils";
import { updateUserInfo } from "reducers/user/actions";
import { forgetPassword, updateUserPassword } from "services/auth";
import { showAlert } from "reducers/alerts/actions";

// import ProfileCard from "components/EnergyCompany/Cards/ProfileCard.jsx";
// import avatar from "assets/img/faces/marc.jpg";

const styles = {
  forgetPassword: {
    cursor: "pointer",
    marginLeft: "10px",
  },
};

class UserProfile extends Component {
  state = {
    confirmacaoSenha: "",
    cpf: "",
    nome: "",
    senha: "",
    senhaAntiga: "",
    sobrenome: "",
    telefone: "",
    updatingInfo: false,
    updatingPassword: false,
  };

  componentDidMount() {
    this.setUserInfo();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.user, this.props.user)) {
      this.setUserInfo();
    }
  }

  forgetPassword = () => {
    const { email } = this.props.user.info;
    this.setState({ updatingPassword: true });

    forgetPassword(email)
      .then(() => {
        this.props.showAlert({ message: <span>E-mail enviado para <strong>{email}</strong></span>, type: "info" });
        this.setState({ updatingPassword: false });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  setUserInfo() {
    const { info } = this.props.user;

    if (info) {
      this.setState({
        cpf: info.cpf || "",
        nome: info.nome || "",
        sobrenome: info.sobrenome || "",
        telefone: info.telefone || "",
      });
    }
  }

  updateUserInfo = () => {
    const { cpf, nome, sobrenome, telefone } = this.state;
    this.setState({ updatingInfo: true });

    this.props.updateUserInfo({ cpf, nome, sobrenome, telefone: removeNonDigits(telefone) })
      .then(() => {
        this.props.showAlert({ message: "Informações atualizadas com sucesso.", type: "info" });
        this.setState({ updatingInfo: false });
      })
      .catch(() => {
        this.props.showAlert({ message: "Não conseguimos atualizar suas informações, por favor tente mais tarde.", type: "error" });
        this.setState({ updatingInfo: false });
      });
  }

  updatePassword = () => {
    const { confirmacaoSenha, senha, senhaAntiga } = this.state;
    this.setState({ updatingPassword: true });

    updateUserPassword({ confirmacaoSenha, senha, senhaAntiga })
      .then(() => {
        this.props.showAlert({ message: "Senha atualizada com sucesso.", type: "info" });
        this.setState({
          confirmacaoSenha: "",
          senha: "",
          senhaAntiga: "",
          updatingPassword: false,
        });
      })
      .catch(error => {
        this.props.showAlert({ message: values(error.response.data).join(' '), type: "error" });
        this.setState({ updatingPassword: false });
      });
  }

  render() {
    const {
      confirmacaoSenha,
      cpf,
      nome,
      senha,
      senhaAntiga,
      sobrenome,
      telefone,
      updatingInfo,
      updatingPassword } = this.state;

    return (
      <div>
        <GridContainer>
          <GridItem md={12} sm={12} xs={12}>
            <ECCard
              content={
                <div>
                  <GridContainer>
                    <GridItem md={6} sm={12} xs={12}>
                      <CustomInput
                        error={!nome}
                        formControlProps={{ fullWidth: true }}
                        inputProps={{
                          disabled: updatingInfo,
                          onChange: e => this.setState({ nome: e.target.value }),
                          value: nome,
                        }}
                        labelText="Nome*"
                      />
                    </GridItem>

                    <GridItem md={6} sm={12} xs={12}>
                      <CustomInput
                        error={!sobrenome}
                        formControlProps={{ fullWidth: true }}
                        inputProps={{
                          disabled: updatingInfo,
                          onChange: e => this.setState({ sobrenome: e.target.value }),
                          value: sobrenome,
                        }}
                        labelText="Sobrenome*"
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem md={6} sm={12} xs={12}>
                      <CustomInput
                        error={!telefone}
                        formControlProps={{ fullWidth: true }}
                        inputProps={{
                          disabled: updatingInfo,
                          onChange: e => this.setState({ telefone: e.target.value }),
                          value: telefoneMask(telefone),
                        }}
                        labelText="Telefone*"
                      />
                    </GridItem>

                    <GridItem md={6} sm={12} xs={12}>
                      <CustomInput
                        formControlProps={{ fullWidth: true }}
                        inputProps={{
                          disabled: true,
                          value: CPFMask(cpf),
                        }}
                        labelText="CPF"
                      />
                    </GridItem>

                    <GridItem md={6} sm={12} xs={12}>
                      <CustomInput
                        formControlProps={{ fullWidth: true }}
                        inputProps={{
                          disabled: true,
                          value: get(this.props.user, "info.email", ""),
                        }}
                        labelText="Email"
                      />
                    </GridItem>
                  </GridContainer>
                  {updatingInfo ? <BouncingLoader /> : (
                    <Button
                      color="rose"
                      disabled={!nome || !sobrenome || !telefone || removeNonDigits(telefone).length < 11}
                      onClick={this.updateUserInfo}
                    >
                      Editar Informações
                    </Button>
                  )}
                </div>
              }
              icon={<PermIdentity />}
              title="Perfil"
            />
          </GridItem>

          <GridItem md={12} sm={12} xs={12}>
            <ECCard
              content={
                <div>
                  <GridContainer>
                    <GridItem md={6} sm={12} xs={12}>
                      <CustomInput
                        formControlProps={{ fullWidth: true }}
                        inputProps={{
                          autoComplete: "current-password",
                          onChange: e => this.setState({ senhaAntiga: e.target.value }),
                          type: "password",
                          value: senhaAntiga,
                        }}
                        labelText="Senha Atual"
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem md={6} sm={12} xs={12}>
                      <CustomInput
                        formControlProps={{ fullWidth: true }}
                        inputProps={{
                          autoComplete: "new-password",
                          onChange: e => this.setState({ senha: e.target.value }),
                          type: "password",
                          value: senha,
                        }}
                        labelText="Nova Senha"
                      />
                   </GridItem>

                    <GridItem md={6} sm={12} xs={12}>
                      <CustomInput
                        formControlProps={{ fullWidth: true }}
                        inputProps={{
                          autoComplete: "new-password",
                          onChange: e => this.setState({ confirmacaoSenha: e.target.value }),
                          type: "password",
                          value: confirmacaoSenha,
                        }}
                        labelText="Confirmar Nova Senha"
                      />
                    </GridItem>

                  </GridContainer>
                  {updatingPassword ? <BouncingLoader /> : (
                    <div>
                      <Button
                        color="rose"
                        disabled={!confirmacaoSenha || !senha || !senhaAntiga}
                        onClick={this.updatePassword}
                      >
                        Salvar nova senha
                      </Button>
                      <a className={this.props.classes.forgetPassword} onClick={this.forgetPassword}>
                        Esqueceu a senha?
                      </a>
                    </div>
                  )}
                </div>
              }
              icon={<Fingerprint />}
              title="Senha"
            />
          </GridItem>

          {/* IDEA: Caso a gente precise de foto ou outros detalhes. */}
          {/* <GridItem md={4} sm={12} xs={12}>
            <ProfileCard
              avatar={avatar}
              content={
                <Button color="rose" round>
                  Follow
                </Button>
              }
              description="Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is..."
              subtitle="CEO / CO-FOUNDER"
              title="Alec Thompson"
            />
          </GridItem> */}
        </GridContainer>
      </div>
    );
  }
}

UserProfile.propTypes = {
  classes: PropTypes.object.isRequired,
  showAlert: PropTypes.func.isRequired,
  updateUserInfo: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps ={
  showAlert,
  updateUserInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserProfile));



// WEBPACK FOOTER //
// ./src/views/User/UserProfile.jsx